<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="doc-preview-modal-dialog"
  [style]="{ width: '840px', maxWidth: '95vw', maxHeight: '92vh' }"
  [contentStyle]="{ 'display': 'flex', 'flex-direction': 'column', 'flex': '1 1 auto', 'min-height': '0', 'overflow': 'hidden', 'padding': '0 1.25rem 0.25rem 1.25rem' }"
  (onHide)="handleClose()"
>
  <!-- Modal Header -->
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center w-100 justify-content-between">
      <h5 class="modal-title fw-semibold mb-0" style="color: #151515; font-size: 1.15rem;">
        Document Preview
      </h5>
    </div>
  </ng-template>

  <div class="preview-modal-wrapper">
    <!-- Document Information Bar with Change option -->
    <div class="doc-info-bar d-flex align-items-center justify-content-between p-2 px-3 mb-2 border rounded">
      <div class="d-flex align-items-center text-truncate me-2">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="text-secondary me-2 flex-shrink-0"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        <span class="doc-file-name text-truncate fw-medium" [title]="fileName" style="font-size: 0.9rem; color: #212529;">
          {{ fileName }}
        </span>
      </div>

      <div class="flex-shrink-0" *ngIf="canChangeFile">
        <a
          href="javascript:void(0)"
          class="change-doc-link clickable text-decoration-underline fw-medium"
          style="color: #612e86; font-size: 0.85rem;"
          (click)="triggerChangeFile()"
        >
          Change
        </a>
        <input
          #fileChangeInput
          type="file"
          [accept]="fileType === 'image' ? 'image/jpeg,image/png' : '.pdf,application/pdf'"
          [multiple]="multiple"
          [hidden]="true"
          (change)="onNewFileSelected($event)"
        />
      </div>
    </div>

    <!-- Landscape Pages Detected Alert Banner with 1-Click Action -->
    <div
      *ngIf="fileType === 'pdf' && hasLandscapePages && !isRotatedSuccessfully"
      class="landscape-alert-banner d-flex align-items-center justify-content-between p-2 px-3 mb-2 border rounded"
    >
      <div class="d-flex align-items-center me-2">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#612e86"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="me-2 flex-shrink-0"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <div>
          <div class="fw-semibold" style="font-size: 0.88rem; color: #3b1d5c;">
            Landscape pages detected ({{ landscapePageCount }} {{ landscapePageCount === 1 ? 'page' : 'pages' }})
          </div>
          <div class="text-muted" style="font-size: 0.78rem;">
            You can optionally rotate landscape pages to portrait if preferred. Portrait pages remain unchanged.
          </div>
        </div>
      </div>
      <div class="flex-shrink-0">
        <button
          type="button"
          class="btn btn-sm btn-rotate-action px-3 py-1 d-inline-flex align-items-center"
          (click)="rotateLandscapePages()"
          [disabled]="isRotating"
        >
          <i class="bx bx-rotate-right me-1" *ngIf="!isRotating" style="font-size: 1rem;"></i>
          <i class="bx bx-loader-alt bx-spin me-1" *ngIf="isRotating" style="font-size: 1rem;"></i>
          {{ isRotating ? 'Rotating...' : 'Rotate to Portrait' }}
        </button>
      </div>
    </div>

    <!-- Rotation Success Banner -->
    <div
      *ngIf="fileType === 'pdf' && isRotatedSuccessfully"
      class="landscape-success-banner d-flex align-items-center justify-content-between p-2 px-3 mb-2 border rounded"
    >
      <div class="d-flex align-items-center me-2">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#15803d"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="me-2 flex-shrink-0"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        <span class="fw-medium text-success-emphasis" style="font-size: 0.85rem;">
          All landscape pages have been rotated to portrait.
        </span>
      </div>
      <button
        type="button"
        class="btn-close btn-sm"
        aria-label="Close"
        (click)="isRotatedSuccessfully = false"
      ></button>
    </div>

    <!-- Document Viewer Canvas Area -->
    <div class="preview-stage-container position-relative rounded border p-2 p-md-3">
      <!-- Floating Action Controls: Zoom & Rotate -->
      <div class="viewer-floating-actions" *ngIf="fileType === 'pdf'">
        <button
          type="button"
          class="viewer-action-btn"
          (click)="toggleZoom()"
          title="Zoom Toggle"
          aria-label="Zoom Toggle"
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            <line x1="11" y1="8" x2="11" y2="14"></line>
            <line x1="8" y1="11" x2="14" y2="11"></line>
          </svg>
        </button>

        <button
          type="button"
          class="viewer-action-btn"
          [disabled]="!hasLandscapePages || isRotating"
          [class.disabled-btn]="!hasLandscapePages"
          (click)="rotateLandscapePages()"
          [title]="hasLandscapePages ? 'Rotate landscape pages to portrait' : 'Rotate disabled - no landscape pages found'"
          [attr.aria-label]="hasLandscapePages ? 'Rotate landscape pages to portrait' : 'Rotate disabled - no landscape pages found'"
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            [class.spin-anim]="isRotating"
          >
            <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
          </svg>
        </button>
      </div>

      <!-- PDF Viewer Body (Vertically Scrollable All Pages) -->
      <div
        #scrollContainer
        class="viewer-scroll-viewport position-relative"
        (scroll)="onContainerScroll($event)"
        *ngIf="fileType === 'pdf'"
      >
        <div
          *ngFor="let pageNum of pageNumbers"
          [id]="'preview-page-' + pageNum"
          class="pdf-page-container position-relative"
        >
          <canvas
            [id]="'canvas-page-' + pageNum"
            class="rendered-canvas-page shadow"
            style="border-radius: 4px; background: #fff; max-width: 95%; display: block;"
          ></canvas>
        </div>

        <div *ngIf="isLoading" class="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center justify-content-center p-4 bg-white rounded shadow-sm">
          <div class="spinner-border text-primary mb-2" role="status" style="width: 2rem; height: 2rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <small class="text-muted fw-medium">Loading document preview...</small>
        </div>

        <div *ngIf="hasError" class="position-absolute top-50 start-50 translate-middle text-center p-4">
          <i class="bx bx-error-circle text-danger" style="font-size: 2.5rem;"></i>
          <p class="text-muted mt-2 mb-0">Unable to render preview for this document.</p>
        </div>
      </div>

      <!-- Image Viewer Body -->
      <div class="viewer-scroll-viewport d-flex justify-content-center align-items-center" *ngIf="fileType === 'image'">
        <img
          *ngIf="imageUrl"
          [src]="imageUrl"
          alt="Preview"
          class="img-fluid rounded shadow-sm"
          [style.transform]="'scale(' + zoomLevel + ')'"
          style="max-height: 420px; object-fit: contain;"
        />
      </div>

      <!-- Template HTML Viewer Body -->
      <div class="viewer-scroll-viewport template-viewport p-3 bg-white rounded shadow-sm" *ngIf="fileType === 'template'">
        <div [innerHTML]="htmlContent || '<p>No preview available</p>'"></div>
      </div>

      <!-- Bottom Pagination (for PDF) -->
      <div class="pagination-controls d-flex align-items-center justify-content-center mt-2 gap-2" *ngIf="fileType === 'pdf'">
        <button
          type="button"
          class="btn btn-sm btn-light border p-1 d-flex align-items-center justify-content-center page-nav-btn"
          [disabled]="currentPage <= 1"
          (click)="prevPage()"
          style="width: 28px; height: 28px; border-radius: 4px;"
        >
          <i class="bx bx-chevron-left" style="font-size: 1.1rem;"></i>
        </button>

     

        <button
          type="button"
          class="btn btn-sm btn-light border p-1 d-flex align-items-center justify-content-center page-nav-btn"
          [disabled]="currentPage >= totalPages"
          (click)="nextPage()"
          style="width: 28px; height: 28px; border-radius: 4px;"
        >
          <i class="bx bx-chevron-right" style="font-size: 1.1rem;"></i>
        </button>

           <div class="d-flex align-items-center gap-1">
          <span class="page-indicator text-muted" style="font-size: 0.8rem; font-weight: 500;">
            Page {{ currentPage }} of {{ totalPages }}
          </span>
          <span
            *ngIf="pageOrientations[currentPage - 1] === 'landscape'"
            class="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle ms-1"
            style="font-size: 0.72rem; font-weight: 500;"
            title="This page is landscape"
          >
            Landscape
          </span>
          <span
            *ngIf="pageOrientations[currentPage - 1] === 'portrait' && (hasLandscapePages || isRotatedSuccessfully)"
            class="badge bg-light text-muted border ms-1"
            style="font-size: 0.72rem; font-weight: 500;"
          >
            Portrait
          </span>
        </div>
        
      </div>
    </div>
  </div>

  <!-- Modal Footer -->
  <ng-template pTemplate="footer">
    <div class="d-flex align-items-center justify-content-end gap-2 pt-2">
      <ng-container *ngIf="mode === 'upload'">
        <button
          type="button"
          class="btn btn-outline-secondary px-4 py-2"
          style="font-size: 0.85rem;"
          (click)="handleCancel()"
        >
          Close
        </button>
        <button
          type="button"
          class="btn text-white px-4 py-2"
          style="background-color: #612e86; border-color: #612e86; font-size: 0.85rem;"
          (click)="handleUpload()"
        >
          Upload
        </button>
      </ng-container>

      <ng-container *ngIf="mode !== 'upload'">
        <button
          type="button"
          class="btn btn-outline-secondary px-4 py-2"
          style="font-size: 0.85rem;"
          (click)="handleClose()"
        >
          Close
        </button>
        <button
          *ngIf="hasChanges"
          type="button"
          class="btn text-white px-4 py-2 ms-2"
          style="background-color: #612e86; border-color: #612e86; font-size: 0.85rem;"
          (click)="saveAndClose()"
        >
          Save Changes
        </button>
      </ng-container>
    </div>
  </ng-template>
</p-dialog>

<!-- Pre-Upload Landscape Prompt Dialog -->
<p-dialog
  [(visible)]="showLandscapeUploadPrompt"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '460px', maxWidth: '92vw' }"
  styleClass="rotate-prompt-dialog"
>
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center gap-2">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#612e86" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <h6 class="modal-title fw-semibold mb-0" style="color: #151515; font-size: 1rem;">
        Landscape Pages Detected
      </h6>
    </div>
  </ng-template>

  <div class="py-2">
    <p class="mb-2" style="font-size: 0.88rem; color: #374151;">
      This document contains <strong>{{ landscapePageCount }}</strong> landscape {{ landscapePageCount === 1 ? 'page' : 'pages' }}.
    </p>
    <p class="mb-0 text-muted" style="font-size: 0.82rem;">
      Signing works properly in both orientations. You can optionally rotate landscape pages to portrait if preferred, or upload as-is.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex align-items-center justify-content-end gap-2 pt-2">
      <button
        type="button"
        class="btn btn-outline-secondary px-3 py-1"
        style="font-size: 0.85rem;"
        (click)="confirmUploadAsIs()"
      >
        Upload As-Is
      </button>
      <button
        type="button"
        class="btn text-white px-3 py-1"
        style="background-color: #612e86; border-color: #612e86; font-size: 0.85rem;"
        (click)="confirmRotateAndUpload()"
        [disabled]="isRotating"
      >
        <i class="bx bx-rotate-right me-1" *ngIf="!isRotating"></i>
        <i class="bx bx-loader-alt bx-spin me-1" *ngIf="isRotating"></i>
        Rotate & Upload
      </button>
    </div>
  </ng-template>
</p-dialog>
